var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { class: { scrolled: _vm.scrolled } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "h1",
        { staticClass: "logo" },
        [
          _c("router-link", { attrs: { to: { name: "home" } } }, [
            _vm._v("Krnny Pilates")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter" },
        [
          _c(
            "a",
            {
              staticClass: "mhandle",
              attrs: { href: "" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("toggleMenu")
                }
              }
            },
            [_c("span")]
          ),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tools" }, [
        true || !_vm.isAdminPart
          ? _c(
              "div",
              { staticClass: "subsc" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "subsctoggle",
                    class: { active: _vm.$route.name == "packages" },
                    attrs: { to: { name: "packages" } }
                  },
                  [_vm._v("\n          Subscriptions\n        ")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cart", class: { open: _vm.cartOpen } },
          [
            _c(
              "a",
              {
                staticClass: "stoggle",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.cartOpen = !_vm.cartOpen
                  }
                }
              },
              [
                _vm.cart.cartItems && _vm.cart.cartItems.length
                  ? _c("span", [_vm._v(_vm._s(_vm.cart.cartItems.length))])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("cart")
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "search", class: { open: _vm.searchOpen } }, [
          _c("a", {
            staticClass: "stoggle",
            attrs: { href: "" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.searchOpen = !_vm.searchOpen
              }
            }
          }),
          _vm._v(" "),
          _c("form", [
            _c("input", {
              ref: "searchfield",
              attrs: { type: "text", placeholder: "Search here..." }
            }),
            _vm._v(" "),
            _c("button", [_vm._v("Search")])
          ])
        ]),
        _vm._v(" "),
        !_vm.loggedIn
          ? _c(
              "div",
              { staticClass: "user-control", class: { open: _vm.isuseropen } },
              [
                _c("a", {
                  staticClass: "mob-user-handle",
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.isuseropen = !_vm.isuseropen
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    attrs: { to: { name: "user.register" } },
                    nativeOn: {
                      click: function($event) {
                        _vm.isuseropen = false
                      }
                    }
                  },
                  [_vm._v("Register")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    attrs: { to: { name: "user.login" } },
                    nativeOn: {
                      click: function($event) {
                        _vm.isuseropen = false
                      }
                    }
                  },
                  [_vm._v("Login")]
                )
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "user-control", class: { open: _vm.isuseropen } },
              [
                _c("a", {
                  staticClass: "mob-user-handle",
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.isuseropen = !_vm.isuseropen
                    }
                  }
                }),
                _vm._v(" "),
                _vm.loggedIn.admin
                  ? _c(
                      "router-link",
                      {
                        attrs: { to: { name: "admin.videos" } },
                        nativeOn: {
                          click: function($event) {
                            _vm.isuseropen = false
                          }
                        }
                      },
                      [_vm._v("Admin")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: { href: "" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.doLogout()
                        _vm.isuseropen = false
                      }
                    }
                  },
                  [_vm._v("Logout")]
                )
              ],
              1
            )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hbg" }, [
      _c("div", { staticClass: "container" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }